import React from "react";
import {
  DocumentTextIcon,
  ArrowDownTrayIcon,
} from "@heroicons/react/24/outline";

export default function Reports() {
  return (
    <div className="p-6 space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-semibold text-gray-800">Reports</h2>

        <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-2">
          <ArrowDownTrayIcon className="h-5 w-5" />
          Download Report
        </button>
      </div>

      {/* Filters */}
      <div className="bg-white p-4 shadow rounded-lg grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="text-gray-500 text-sm">Report Type</label>
          <select className="w-full border p-2 mt-1 rounded">
            <option>Leave Summary</option>
            <option>Attendance Report</option>
            <option>Team Performance</option>
          </select>
        </div>

        <div>
          <label className="text-gray-500 text-sm">From</label>
          <input type="date" className="w-full border p-2 mt-1 rounded" />
        </div>

        <div>
          <label className="text-gray-500 text-sm">To</label>
          <input type="date" className="w-full border p-2 mt-1 rounded" />
        </div>
      </div>

      {/* Report Preview */}
      <div className="bg-white p-6 shadow rounded-lg">
        <h3 className="text-lg font-medium mb-4 flex items-center gap-2">
          <DocumentTextIcon className="h-6 w-6 text-gray-700" />
          Report Preview
        </h3>

        <table className="w-full border mt-3">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="p-3 border">#</th>
              <th className="p-3 border">Employee</th>
              <th className="p-3 border">Department</th>
              <th className="p-3 border">Leaves Taken</th>
              <th className="p-3 border">Pending</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="p-3 border">1</td>
              <td className="p-3 border">John Doe</td>
              <td className="p-3 border">Engineering</td>
              <td className="p-3 border">5</td>
              <td className="p-3 border">2</td>
            </tr>

            <tr className="bg-gray-50">
              <td className="p-3 border">2</td>
              <td className="p-3 border">Priya Sharma</td>
              <td className="p-3 border">Marketing</td>
              <td className="p-3 border">3</td>
              <td className="p-3 border">1</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
